import React, { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import { Row, Table, Col, Spinner, Button, FormGroup } from "reactstrap";
import { Form } from "react-bootstrap";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import "../../styles/Users.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@mantis-sas/ui";
import BulkUploadClientButton from "../Clients/Buttons/BulkUploadClientButton";

import {
  createMantisBusinessUser,
  updateMantisBusinessUser,
  getMantisBusinessUsers,
  deleteMantisBusinessUser,
  getMantisBusinessGroups,
} from "../../../ApiCalls/mantisBusiness";
import { getMyAccess } from "../../../ApiCalls/mantisAccess";
import { accesoConfigurado } from "../../../utils/cierreAcceso";
import { selectAuthState } from "../../../store/selectors/authSelectors";
import { AccesoUsuarios } from "../Cierres/AccesoUsuarios";
import { guia } from "../../../utils/cierreTours";
import { BotonGuia } from "../Cierres/GuiaPantalla";

// BR-37: a cierres business whose people hold assignments (`npm run access:seed` gives everyone
// one) gets `AccesoUsuarios` instead of the table below — roles and scopes in place of the
// ADMIN / SUPERVISOR / USER dropdown and the legacy permission list, which mean nothing to a
// cierre. Only a CONCILIACION business is even asked: every other tenant renders exactly what it
// did, without one extra request. Creating, editing and deleting a user still go through this
// file's modal and the legacy routes, whose rules (BR-33) are the legacy role's.
const esNegocioDeCierres = (mantisBusiness) => mantisBusiness?.clientType === "CONCILIACION";

// B-176 — the user modal in the Cierres shell's look (`brinks-scope`, the shell's sizes and tokens)
// for a cierres business; every other business keeps the modal it always had.
const ESTILO_ANTERIOR = {
  contenido: "max-w-4xl max-h-[90vh] overflow-y-auto",
  encabezado: undefined,
  tituloFila: "flex items-center space-x-3",
  icono: "p-2 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-xl shadow-sm",
  iconoSvg: "w-5 h-5 text-white",
  titulo: "text-slate-900 dark:text-slate-100",
  descripcion: undefined,
  cuerpo: "py-4",
  bloques: "space-y-8",
  bloque: "space-y-6",
  seccion: "flex items-center space-x-2 pb-2 border-b border-slate-200/50 dark:border-slate-700/50",
  seccionIcono: "w-5 h-5 text-indigo-600 dark:text-indigo-400",
  seccionTitulo: "text-lg font-medium text-slate-900 dark:text-slate-100",
  etiqueta: "text-sm font-medium text-slate-700 dark:text-slate-300",
  campo: "w-full px-4 py-3 bg-white/50 dark:bg-slate-700/50 border border-slate-300/50 dark:border-slate-600/50 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all text-slate-900 dark:text-slate-100",
  area: "w-full px-4 py-3 bg-white/50 dark:bg-slate-700/50 border border-slate-300/50 dark:border-slate-600/50 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all text-slate-900 dark:text-slate-100 resize-none",
  clave: "w-full px-4 py-3 pr-12 bg-white/50 dark:bg-slate-700/50 border border-slate-300/50 dark:border-slate-600/50 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all text-slate-900 dark:text-slate-100",
  nota: "text-xs text-slate-500 dark:text-slate-400",
  verClave: "absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300 transition-colors",
  verClaveSvg: "w-5 h-5",
  selectClase: "react-select-clean",
  select: undefined,
  pie: "gap-2",
  cancelar: "px-6 py-3 text-sm font-medium text-slate-700 dark:text-slate-300 bg-white/50 dark:bg-slate-700/50 border border-slate-300/50 dark:border-slate-600/50 rounded-xl hover:bg-slate-50 dark:hover:bg-slate-700 transition-all",
  guardar: "px-6 py-3 text-sm font-medium text-white bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 rounded-xl shadow-sm transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2",
};

const CAMPO_CIERRES =
  "h-9 w-full rounded-[8px] border border-brinks-border bg-card px-2.5 text-[13px] text-brinks-foreground shadow-none outline-none transition placeholder:text-brinks-muted-foreground focus:border-brinks-border-strong focus:shadow-none";

const ESTILO_CIERRES = {
  contenido: "brinks-scope font-redhat flex max-h-[90vh] max-w-2xl flex-col gap-0 overflow-hidden p-0",
  encabezado: "border-b p-4 pr-24 text-left",
  tituloFila: "flex items-center gap-3",
  icono: "grid h-9 w-9 shrink-0 place-items-center rounded-[8px] border bg-card text-brinks-foreground shadow-brinks-card",
  iconoSvg: "h-[18px] w-[18px]",
  titulo: "text-[16px] font-semibold text-brinks-foreground",
  descripcion: "text-[12.5px] text-brinks-muted-foreground",
  cuerpo: "min-h-0 flex-1 overflow-y-auto px-4 py-3",
  bloques: "space-y-5",
  bloque: "space-y-3",
  seccion: "flex items-center gap-2 border-b border-brinks-border pb-1.5",
  seccionIcono: "h-4 w-4 text-brinks-muted-foreground",
  seccionTitulo: "m-0 text-[11px] font-semibold uppercase tracking-[0.04em] text-brinks-muted-foreground",
  etiqueta: "mb-1 text-[12px] font-medium text-brinks-muted-foreground",
  campo: CAMPO_CIERRES,
  area: `${CAMPO_CIERRES} h-auto min-h-[72px] resize-y py-2`,
  clave: `${CAMPO_CIERRES} pr-10`,
  nota: "mt-1 text-[11.5px] text-brinks-muted-foreground",
  verClave: "absolute right-2.5 top-1/2 -translate-y-1/2 text-brinks-muted-foreground transition hover:text-brinks-foreground",
  verClaveSvg: "h-4 w-4",
  // react-select draws its own box: the same height, radius, border and type as the fields — and
  // not `react-select-clean`, whose stylesheet makes it 48 px and indigo.
  selectClase: undefined,
  select: {
    control: (base, state) => ({
      ...base,
      minHeight: 36,
      borderRadius: 8,
      borderColor: state.isFocused ? "var(--brinks-border-strong)" : "var(--brinks-border)",
      boxShadow: "none",
      fontSize: 13,
      "&:hover": { borderColor: "var(--brinks-border-strong)" },
    }),
    placeholder: (base) => ({ ...base, color: "var(--brinks-muted-foreground)" }),
    multiValue: (base) => ({ ...base, borderRadius: 6, backgroundColor: "var(--brinks-surface)" }),
    valueContainer: (base) => ({ ...base, padding: "0 8px" }),
    menu: (base) => ({ ...base, borderRadius: 8, fontSize: 13, zIndex: 60 }),
    option: (base, state) => ({
      ...base,
      fontSize: 13,
      color: "var(--brinks-foreground)",
      backgroundColor: state.isFocused ? "var(--brinks-surface-hover)" : "transparent",
    }),
  },
  pie: "flex-row justify-end gap-2 border-t p-3 sm:space-x-0",
  cancelar:
    "inline-flex h-9 items-center rounded-[8px] border border-brinks-border bg-card px-4 text-[12.5px] font-medium text-brinks-foreground transition hover:bg-brinks-surface-hover disabled:opacity-60",
  guardar:
    "inline-flex h-9 items-center gap-1.5 rounded-[8px] bg-primary px-4 text-[12.5px] font-medium text-primary-foreground transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50",
};

function BusinessUsers(props) {
  const [mantisBusinessUsers, setMantisBusinessUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creatingNewUser, setCreatingNewUser] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [loadingCreatingNewUser, setLoadingCreatingNewUser] = useState(false);
  const [loadingEditingUser, setLoadingEditingUser] = useState(false);
  const [, setNewUserFormValidated] = useState(false);
  const [, setEditingUserFormValidated] =
    useState(false);
  const [permisosModal, setPermisosModal] = useState(null); // { nombre, permisos: string[] } | null
  const [, setMantisBusinessGroups] = useState([]);
  const [, setGroupOptions] = useState([]);

  const [newUserForm, setNewUserForm] = useState({
    firstName: "",
    lastName: "",
    documentId: "",
    corporateEmail: "",
    password: "",
    confirmPassword: "",
    cellPhone: "",
    position: "",
    permissions: [],
    role: "USER",
    userGroups: [],
    context: "",
    language: "es",
    favorite_channel: "",
  });

  const [permissionsOptions, setPermissionsOptions] = useState([]);
  const [userPermissions, setUserPermissions] = useState([]);
  const [userGroupOptions, setUserGroupOptions] = useState([]);

  const [formValidated, setFormValidated] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // undefined while asking, null for today's screen, or `/access/me`'s answer for the new one. A
  // failed or refused answer is today's screen: it is what this business had before BR-37.
  const cierres = esNegocioDeCierres(props.mantisBusiness);
  const [acceso, setAcceso] = useState(cierres ? undefined : null);
  const [recargaAcceso, setRecargaAcceso] = useState(0);
  const recargarAcceso = () => setRecargaAcceso((n) => n + 1);

  useEffect(() => {
    if (!cierres) {
      setAcceso(null);
      return undefined;
    }
    let activo = true;
    getMyAccess(props.token)
      .then((res) => activo && setAcceso(res?.success && accesoConfigurado(res.data) ? res.data : null))
      .catch(() => activo && setAcceso(null));
    return () => {
      activo = false;
    };
  }, [cierres, props.token, props.mantisBusiness._id]);

  const clearNewUserForm = () => {
    setNewUserForm({
      firstName: "",
      lastName: "",
      documentId: "",
      corporateEmail: "",
      password: "",
      confirmPassword: "",
      cellPhone: "",
      position: "",
      permissions: [],
      role: "USER",
      userGroups: [],
      context: "",
      language: "es",
      favorite_channel: "",
    });
    setNewUserFormValidated(false);
    setShowPassword(false);
    setShowConfirmPassword(false);
  };

  // Compact pills instead of the old vertical, expand-in-place list — that one grew the row to
  // 300px of near-invisible text (`.permission-item`'s `dark:` classes lit up against a light
  // background whenever the app's global dark-mode class was on, since this cell has no local
  // override). A handful of pills plus a count, with the full list one click away in a dialog,
  // keeps every row a fixed height and uses the row's own width instead of its height.
  const PERMISOS_VISIBLES = 3;

  const formatPermissions = (permissions, userName) => {
    if (!permissions || permissions.length === 0) return "-";

    const formattedPermissions = permissions.map((p) => {
      const permission = typeof p === "string" ? p : p.permission;
      const foundPermission = props.mantisBusiness.enabledPermissions.find(
        (ep) => ep.permission === permission
      );
      return foundPermission ? foundPermission.friendlyName : permission;
    });

    const visibles = formattedPermissions.slice(0, PERMISOS_VISIBLES);
    const restantes = formattedPermissions.length - visibles.length;

    return (
      <div className="flex flex-wrap items-center gap-1">
        {visibles.map((permission, index) => (
          <span
            key={index}
            className="inline-flex items-center rounded bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-700 dark:bg-slate-700 dark:text-slate-200"
          >
            {permission}
          </span>
        ))}
        {restantes > 0 && (
          <button
            type="button"
            onClick={() => setPermisosModal({ nombre: userName, permisos: formattedPermissions })}
            className="inline-flex items-center rounded bg-indigo-50 px-2 py-0.5 text-xs font-semibold text-indigo-700 hover:bg-indigo-100 dark:bg-indigo-900/40 dark:text-indigo-300"
          >
            +{restantes} más
          </button>
        )}
      </div>
    );
  };

  const fetchUserGroups = useCallback(async () => {
    try {
      const res = await getMantisBusinessGroups(
        props.mantisBusiness._id,
        props.token
      );
      if (res.success) {
        const options = res.groups.map((group) => ({
          value: group._id,
          label: group.name,
        }));
        setUserGroupOptions(options);
      } else {
        console.error("Error fetching user groups:", res.message);
      }
    } catch (error) {
      console.error("Error fetching user groups:", error);
    }
  }, [props.mantisBusiness._id, props.token]);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const res = await getMantisBusinessUsers(
          props.mantisBusiness._id,
          props.token
        );
        if (res.success) {
          setMantisBusinessUsers(res.users || []);
        } else {
          toast.error(res.message || "Error al obtener usuarios");
        }
      } catch (error) {
        toast.error("Error al cargar usuarios");
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    // L-01 (MA-06): not gated on props.token — the JWT lives in an httpOnly cookie, so
    // Redux holds "" on reload and undefined after login. Gating on it left `loading`
    // stuck at its initial true and the section spinning forever.
    if (props.mantisBusiness._id) {
      fetchUsers();
    }
  }, [props.mantisBusiness._id, props.token]);

  useEffect(() => {
    if (props.mantisBusiness.enabledPermissions) {
      setPermissionsOptions(
        props.mantisBusiness.enabledPermissions.map((permission) => ({
          value: permission.permission,
          label: permission.friendlyName,
        }))
      );
    }
  }, [props.mantisBusiness.enabledPermissions]);

  useEffect(() => {
    fetchUserGroups();
  }, [fetchUserGroups]);

  const getCurrentUserRole = () => {
    if (props.user.mainUser) {
      return "ADMIN";
    } else if (props.user.supervisorUser) {
      return "SUPERVISOR";
    }
    return "USER";
  };

  const canManageRoles = () => {
    const currentRole = getCurrentUserRole();
    return currentRole === "ADMIN";
  };

  const canCreateUsers = () => {
    const currentRole = getCurrentUserRole();
    return (
      currentRole === "ADMIN" ||
      currentRole === "SUPERVISOR" ||
      props.user.permissions?.some((p) => p.permission === "CREATE_USERS")
    );
  };

  
  const getBusinessGroups = useCallback(async () => {
    try {
      const res = await getMantisBusinessGroups(
        props.mantisBusiness._id,
        props.token
      );
      if (res.success) {
        setMantisBusinessGroups(res.groups);
        setGroupOptions(
          res.groups.map((group) => ({
            value: group._id,
            label: group.name,
          }))
        );
      } else {
        console.error("Error fetching groups:", res.message);
      }
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  }, [props.mantisBusiness._id, props.token]);

  useEffect(() => {
    if (props.mantisBusiness._id) {
      getBusinessGroups();
    }
  }, [props.mantisBusiness._id, props.token, getBusinessGroups]);

  const handleCreateNewUser = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setNewUserFormValidated(true);
      return;
    }

    //Password validation
    if (
      newUserForm.password.length < 8 ||
      !/[A-Z]/.test(newUserForm.password)
    ) {
      toast.error(
        "La contraseña debe tener al menos 8 caracteres y una letra mayúscula"
      );
      return;
    }

    if (newUserForm.password !== newUserForm.confirmPassword) {
      toast.error("Las contraseñas no coinciden");
      return;
    }

    if (!canManageRoles()) {
      newUserForm.role = "USER";
    }

    setLoadingCreatingNewUser(true);

    try {
      const userData = {
        ...newUserForm,
        mainUser: canManageRoles() && newUserForm.role === "ADMIN",
        supervisorUser: canManageRoles() && newUserForm.role === "SUPERVISOR",
        cellPhone: newUserForm.cellPhone?.replace(/\s/g, "").replace("+", ""),
        group: newUserForm.group
          ? {
              groupId: newUserForm.group.value,
              groupName: newUserForm.group.label,
            }
          : null,
        context: newUserForm.context || "",
        language: newUserForm.language || "es",
        favorite_channel: newUserForm.favorite_channel || "",
      };

      const res = await createMantisBusinessUser(
        props.mantisBusiness._id,
        props.user._id,
        props.token,
        userData
      );

      if (res.success) {
        // A user created here holds no assignment, so under the access model they see no client
        // until someone gives them one — said now, rather than discovered by them later.
        if (acceso) recargarAcceso();
        toast.success(acceso ? "Usuario creado. Dale acceso a Cierres con el botón Acceso." : "Usuario creado exitosamente", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
          style: {
            background: "#1e1e1e",
            color: "#fff",
            borderRadius: "4px",
            padding: "16px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          },
          progressStyle: {
            background: "linear-gradient(to right, #4cd964, #5ac8fa)",
            height: "2px",
            bottom: 0,
          },
        });
        setMantisBusinessUsers([
          ...mantisBusinessUsers,
          {
            ...res.user,
            groups: userData.userGroups.map((groupId) => ({
              groupId,
              name: userGroupOptions.find((g) => g.value === groupId)?.label,
            })),
          },
        ]);
        setCreatingNewUser(false);
        clearNewUserForm();
      } else {
        throw new Error(res.message || "Error al crear usuario");
      }
    } catch (error) {
      console.error("Error creating user:", error);

      // Verificar si es un error de correo duplicado
      if (
        error.message?.includes("already exists") ||
        error?.response?.status === 405
      ) {
        toast.error(
          "El correo electrónico o el número de celular ya está registrado",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "dark",
            style: {
              background: "#1e1e1e",
              color: "#fff",
              borderRadius: "4px",
              padding: "16px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            },
            progressStyle: {
              background: "linear-gradient(to right, #ff3b30, #ff9500)",
              height: "2px",
              bottom: 0,
            },
          }
        );
      } else {
        toast.error("Error al crear usuario", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
          style: {
            background: "#1e1e1e",
            color: "#fff",
            borderRadius: "4px",
            padding: "16px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          },
          progressStyle: {
            background: "linear-gradient(to right, #ff3b30, #ff9500)",
            height: "2px",
            bottom: 0,
          },
        });
      }
    } finally {
      setLoadingCreatingNewUser(false);
    }
  };

  const handleEditUser = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    // Log inicial de permisos y roles del usuario
    console.log("Current user permissions and roles:", {
      permissions: props.user.permissions,
      isMainUser: props.user.mainUser,
      isSupervisor: props.user.supervisorUser,
    });

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setEditingUserFormValidated(true);
      return;
    }

    // Validación de datos requeridos
    if (!props.user._id || !editingUser._id) {
      console.error("Missing required data:", {
        currentUserId: props.user._id,
        editingUserId: editingUser._id,
        mantisBusinessId: props.mantisBusiness._id,
      });
      toast.error("Faltan datos requeridos para la actualización");
      return;
    }

    if (
      editingUser.password &&
      editingUser.password !== editingUser.confirmPassword
    ) {
      toast.error("Las contraseñas no coinciden");
      return;
    }

    // Verificación de permisos mejorada
    const hasUpdatePermission =
      props.user.permissions?.some((p) => p.permission === "EDIT_USERS") ||
      props.user.mainUser ||
      props.user.supervisorUser;

    console.log("Permission check:", {
      hasEditPermission: props.user.permissions?.some(
        (p) => p.permission === "EDIT_USERS"
      ),
      isMainUser: props.user.mainUser,
      isSupervisor: props.user.supervisorUser,
      finalPermission: hasUpdatePermission,
    });

    if (!hasUpdatePermission) {
      toast.error("No tienes permisos para editar usuarios");
      return;
    }

    setLoadingEditingUser(true);

    try {
      // Preparación y log de datos del usuario
      const userData = {
        firstName: editingUser.firstName,
        lastName: editingUser.lastName,
        documentId: editingUser.documentId,
        corporateEmail: editingUser.corporateEmail,
        position: editingUser.position,
        cellPhone: editingUser.cellPhone?.replace(/\s/g, "").replace("+", ""),
        mainUser: editingUser.role === "ADMIN",
        supervisorUser: editingUser.role === "SUPERVISOR",
        permissions: editingUser.permissions || [],
        groups: editingUser.userGroups.map((groupId) => ({
          groupId,
          name: userGroupOptions.find((g) => g.value === groupId)?.label,
        })),
        context: editingUser.context || "",
        language: editingUser.language || "es",
        favorite_channel: editingUser.favorite_channel || "",
      };

      if (editingUser.password) {
        userData.password = editingUser.password;
      }

      console.log("Sending update request:", {
        mantisBusinessUserId: props.user._id,
        mantisBusinessUserToUpdateId: editingUser._id,
        userData: {
          ...userData,
          password: userData.password ? "***" : undefined,
        },
      });

      const res = await updateMantisBusinessUser(
        props.user._id,
        editingUser._id,
        userData,
        props.token,
        props.mantisBusiness._id
      );

      if (res.success) {
        toast.success("Usuario actualizado exitosamente");
        if (acceso) recargarAcceso();
        setMantisBusinessUsers(
          mantisBusinessUsers.map((user) =>
            user._id === editingUser._id ? res.user : user
          )
        );
        setEditingUser(null);
        setEditingUserFormValidated(false);
      } else {
        console.error("Update failed:", res);
        toast.error(res.message || "Error al actualizar usuario");
      }
    } catch (error) {
      console.error("Error updating user:", error);
      toast.error(
        "Error al actualizar usuario: " + (error.message || "Error desconocido")
      );
    } finally {
      setLoadingEditingUser(false);
    }
  };

  const abrirEdicion = (user) => {
    setEditingUser({
      ...user,
      password: "",
      confirmPassword: "",
      role: user.mainUser ? "ADMIN" : user.supervisorUser ? "SUPERVISOR" : "USER",
      userGroups: (user.groups || []).map((group) => group.groupId),
      context: user.context || "",
      language: user.language || "es",
      favorite_channel: user.favorite_channel || "",
    });
  };

  // The access list names people by id; their personal data is the legacy list's.
  const abrirEdicionPorId = (userId) => {
    const user = mantisBusinessUsers.find((u) => String(u._id) === String(userId));
    if (!user) {
      toast.error("No se encontraron los datos de este usuario");
      return;
    }
    abrirEdicion(user);
  };

  const [porEliminar, setPorEliminar] = useState(null);
  const handleDeleteUser = async (userId, { confirmado = false } = {}) => {
    if (cierres && !confirmado) {
      setPorEliminar(mantisBusinessUsers.find((u) => String(u._id) === String(userId)) || { _id: userId });
      return;
    }
    if (!cierres && !window.confirm("¿Está seguro de eliminar este usuario?")) {
      return;
    }

    try {
      const res = await deleteMantisBusinessUser(
        props.mantisBusiness._id,
        props.user._id,
        userId,
        props.token
      );

      if (res.success) {
        toast.success("Usuario eliminado exitosamente");
        if (acceso) recargarAcceso();
        setMantisBusinessUsers(
          mantisBusinessUsers.filter((user) => user._id !== userId)
        );
      } else {
        toast.error(res.message || "Error al eliminar usuario");
      }
    } catch (error) {
      toast.error("Error al eliminar usuario");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    // Validación para documentId - solo números
    if (name === "documentId" && !/^\d*$/.test(value)) {
      return;
    }

    // Validación para position - solo letras y espacios
    if (name === "position" && !/^[A-Za-zÁáÉéÍíÓóÚúÑñ\s]*$/.test(value)) {
      return;
    }

    if (editingUser) {
      setEditingUser({
        ...editingUser,
        [name]: value,
      });
    } else {
      setNewUserForm({
        ...newUserForm,
        [name]: value,
      });
    }
  };

  const handlePhoneChange = (value) => {
    if (editingUser) {
      setEditingUser({
        ...editingUser,
        cellPhone: value,
      });
    } else {
      setNewUserForm({
        ...newUserForm,
        cellPhone: value,
      });
    }
  };

  const handlePermissionsChange = (selectedOptions) => {
    const selectedPermissions = selectedOptions.map((option) => option.value);
    setUserPermissions(selectedPermissions);
    if (editingUser) {
      setEditingUser({ ...editingUser, permissions: selectedPermissions });
    }
    setNewUserForm({ ...newUserForm, permissions: selectedPermissions });
  };

  const renderUserModal = (isEditing) => {
    const formData = isEditing ? editingUser : newUserForm;
    const E = cierres ? ESTILO_CIERRES : ESTILO_ANTERIOR;
    const BotonPie = cierres ? "button" : Button;
    const loading = isEditing ? loadingEditingUser : loadingCreatingNewUser;
    const isOpen = creatingNewUser || !!editingUser;
    
    const handleSubmit = (e) => {
      e.preventDefault();
      const form = e.currentTarget;
      
      if (form.checkValidity() === false) {
        e.stopPropagation();
        setFormValidated(true);
        return;
      }

      if (isEditing) {
        handleEditUser(e);
      } else {
        handleCreateNewUser(e);
      }
    };

    const handleClose = () => {
      if (isEditing) {
        setEditingUser(null);
      } else {
        setCreatingNewUser(false);
      }
      clearNewUserForm();
      setFormValidated(false);
    };

    return (
      <Dialog open={isOpen} onOpenChange={handleClose}>
        <DialogContent className={E.contenido}>
          <DialogHeader className={E.encabezado}>
            <DialogTitle className={E.tituloFila}>
              <div className={E.icono}>
                <svg className={E.iconoSvg} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <span className={E.titulo}>
                {cierres ? (isEditing ? "Editar usuario" : "Crear usuario") : isEditing ? "Editar Usuario" : "Crear Nuevo Usuario"}
              </span>
            </DialogTitle>
            {/* B-176 — what each field is for. */}
            <BotonGuia
              guiaId="dialogo-usuario"
              titulo={isEditing ? "Editar usuario" : "Crear usuario"}
              texto="Los datos de la persona y su rol en la plataforma. Lo que puede ver y hacer en Cierres se le da después con “Acceso”."
              nombre="Usuario"
              className={cierres ? "absolute right-12 top-3 z-10" : "absolute right-12 top-3"}
            />
            <DialogDescription className={E.descripcion}>
              {isEditing ? "Modifica la información del usuario" : "Completa los datos para crear un nuevo usuario"}
            </DialogDescription>
          </DialogHeader>
          
          <div className={E.cuerpo}>
            <Form onSubmit={handleSubmit} noValidate validated={formValidated}>
              <div className={E.bloques}>
                {/* Personal Information Section */}
                <div className={E.bloque}>
                  <div className={E.seccion}>
                    <svg className={E.seccionIcono} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                    <h4 className={E.seccionTitulo}>
                      Información Personal
                    </h4>
                  </div>
                  
                  <Row>
                    <Col md={6}>
                      <Form.Group {...guia("Nombre", "El nombre de la persona, como aparecerá en la plataforma y en lo que firme.")} className="space-y-2">
                        <Form.Label className={E.etiqueta}>
                          Nombre *
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleInputChange}
                          className={E.campo}
                          placeholder="Ingresa el nombre"
                        />
                        <Form.Control.Feedback type="invalid">
                          El nombre es requerido
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group {...guia("Apellido", "Su apellido.")} className="space-y-2">
                        <Form.Label className={E.etiqueta}>
                          Apellido *
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleInputChange}
                          className={E.campo}
                          placeholder="Ingresa el apellido"
                        />
                        <Form.Control.Feedback type="invalid">
                          El apellido es requerido
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group {...guia("Documento de identidad", "Opcional: su documento.")} className="space-y-2">
                        <Form.Label className={E.etiqueta}>
                          Documento de Identidad
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="documentId"
                          value={formData.documentId}
                          onChange={handleInputChange}
                          className={E.campo}
                          placeholder="Número de documento"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group {...guia("Cargo", "Opcional: su cargo en la empresa.")} className="space-y-2">
                        <Form.Label className={E.etiqueta}>
                          Cargo
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="position"
                          value={formData.position}
                          onChange={handleInputChange}
                          className={E.campo}
                          placeholder="Cargo en la empresa"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>

                {/* Configuration Section */}
                <div className={E.bloque}>
                  <div className={E.seccion}>
                    <svg className={E.seccionIcono} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <h4 className={E.seccionTitulo}>
                      Configuración
                    </h4>
                  </div>
                  
                  <Row>
                    <Col md={6}>
                      <Form.Group {...guia("Contexto", "Opcional: qué hace la persona; lo usa el asistente para responderle mejor.")} className="space-y-2">
                        <Form.Label className={E.etiqueta}>
                          Contexto
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          name="context"
                          value={formData.context || ""}
                          onChange={handleInputChange}
                          className={E.area}
                          placeholder="Contexto específico del usuario (opcional)"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group {...guia("Idioma", "El idioma en que verá la plataforma y recibirá los mensajes.")} className="space-y-2">
                        <Form.Label className={E.etiqueta}>
                          Idioma
                        </Form.Label>
                        <Form.Control
                          as="select"
                          name="language"
                          value={formData.language || "es"}
                          onChange={handleInputChange}
                          className={E.campo}
                        >
                          <option value="es">Español</option>
                          <option value="en">English</option>
                          <option value="pt">Português</option>
                          <option value="fr">Français</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Row>
                    <Col md={6}>
                      <Form.Group {...guia("Canal favorito", "Por dónde prefiere recibir los avisos.")} className="space-y-2">
                        <Form.Label className={E.etiqueta}>
                          Canal Favorito
                        </Form.Label>
                        <Form.Control
                          as="select"
                          name="favorite_channel"
                          value={formData.favorite_channel || ""}
                          onChange={handleInputChange}
                          className={E.campo}
                        >
                          <option value="">Seleccionar canal</option>
                          <option value="whatsapp">WhatsApp</option>
                          <option value="email">Email</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>

                {/* Contact Information Section */}
                <div className={E.bloque}>
                  <div className={E.seccion}>
                    <svg className={E.seccionIcono} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    <h4 className={E.seccionTitulo}>
                      Información de Contacto
                    </h4>
                  </div>

                  <Row>
                    <Col md={6}>
                      <Form.Group {...guia("Email corporativo", "El correo con el que entra a la plataforma. Obligatorio y único.")} className="space-y-2">
                        <Form.Label className={E.etiqueta}>
                          Email Corporativo *
                        </Form.Label>
                        <Form.Control
                          required
                          type="email"
                          name="corporateEmail"
                          value={formData.corporateEmail}
                          onChange={handleInputChange}
                          className={E.campo}
                          placeholder="correo@empresa.com"
                        />
                        <Form.Control.Feedback type="invalid">
                          El email corporativo es requerido
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group {...guia("Teléfono celular", "Opcional: su celular.")} className="space-y-2">
                        <Form.Label className={E.etiqueta}>
                          Teléfono Celular
                        </Form.Label>
                        <PhoneInput
                          international
                          defaultCountry="CO"
                          value={formData.cellPhone}
                          onChange={handlePhoneChange}
                          className="phone-input-clean"
                          style={{
                            width: '100%',
                          }}
                          inputProps={{
                            className: E.campo,
                            placeholder: "Número de teléfono"
                          }}
                        />
                      </Form.Group>
                    </Col>
                    {canManageRoles() && (
                      <Col md={6}>
                        <Form.Group {...guia("Rol en la plataforma", "Decide quién puede crear y editar usuarios. Lo que ve y hace en Cierres se da aparte, con “Acceso”.")} className="space-y-2">
                          <Form.Label className={E.etiqueta}>
                            {acceso ? "Rol en la plataforma" : "Rol"}
                          </Form.Label>
                          <Form.Control
                            as="select"
                            name="role"
                            value={formData.role}
                            onChange={handleInputChange}
                            className={E.campo}
                          >
                            <option value="USER">Usuario</option>
                            <option value="SUPERVISOR">Supervisor</option>
                            <option value="ADMIN">Administrador</option>
                          </Form.Control>
                          {acceso ? (
                            <p className={E.nota}>
                              Decide quién crea, edita y elimina usuarios. El acceso a Cierres se da aparte, con el botón Acceso.
                            </p>
                          ) : null}
                        </Form.Group>
                      </Col>
                    )}
                  </Row>
                </div>

                {/* Security Section */}
                {!isEditing && (
                  <div className={E.bloque}>
                    <div className={E.seccion}>
                      <svg className={E.seccionIcono} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                      </svg>
                      <h4 className={E.seccionTitulo}>
                        Información de Seguridad
                      </h4>
                    </div>

                    <Row>
                      <Col md={6}>
                        <Form.Group {...guia("Contraseña", "La contraseña inicial; la persona puede cambiarla después.")} className="space-y-2">
                          <Form.Label className={E.etiqueta}>
                            Contraseña *
                          </Form.Label>
                          <div className="relative">
                            <Form.Control
                              required
                              type={showPassword ? "text" : "password"}
                              name="password"
                              value={formData.password}
                              onChange={handleInputChange}
                              className={E.clave}
                              placeholder="Mínimo 8 caracteres, una mayúscula"
                            />
                            <button
                              type="button"
                              onClick={() => setShowPassword(!showPassword)}
                              className={E.verClave}
                            >
                              {showPassword ? (
                                <svg className={E.verClaveSvg} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
                                </svg>
                              ) : (
                                <svg className={E.verClaveSvg} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                </svg>
                              )}
                            </button>
                          </div>
                          <Form.Control.Feedback type="invalid">
                            La contraseña es requerida
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="space-y-2">
                          <Form.Label className={E.etiqueta}>
                            Confirmar Contraseña *
                          </Form.Label>
                          <div className="relative">
                            <Form.Control
                              required
                              type={showConfirmPassword ? "text" : "password"}
                              name="confirmPassword"
                              value={formData.confirmPassword}
                              onChange={handleInputChange}
                              className={E.clave}
                              placeholder="Confirma la contraseña"
                            />
                            <button
                              type="button"
                              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                              className={E.verClave}
                            >
                              {showConfirmPassword ? (
                                <svg className={E.verClaveSvg} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
                                </svg>
                              ) : (
                                <svg className={E.verClaveSvg} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                </svg>
                              )}
                            </button>
                          </div>
                          <Form.Control.Feedback type="invalid">
                            Confirma la contraseña
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                )}

                {/* Permissions Section */}
                <div className={E.bloque}>
                  <div className={E.seccion}>
                    <svg className={E.seccionIcono} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                    <h4 className={E.seccionTitulo}>
                      Permisos y Grupos
                    </h4>
                  </div>
                  {acceso ? (
                    <p className={E.nota}>
                      Son de otras secciones de la plataforma y no deciden nada en Cierres.
                    </p>
                  ) : null}

                  <Row>
                    <Col md={6}>
                      <FormGroup className="space-y-2">
                        <Form.Label className={E.etiqueta}>
                          Permisos
                        </Form.Label>
                        <Select
                          isMulti
                          options={permissionsOptions}
                          value={permissionsOptions.filter((option) =>
                            !editingUser
                              ? userPermissions.includes(option.value)
                              : editingUser.permissions.includes(option.value)
                          )}
                          onChange={handlePermissionsChange}
                          placeholder="Selecciona permisos..."
                          className={E.selectClase}
                          classNamePrefix="select"
                          styles={E.select}
                          closeMenuOnSelect={false}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={6}>
                      <FormGroup className="space-y-2">
                        <Form.Label className={E.etiqueta}>
                          Grupos
                        </Form.Label>
                        <Select
                          isClearable
                          isMulti
                          options={userGroupOptions}
                          value={userGroupOptions.filter((option) =>
                            editingUser
                              ? editingUser.userGroups.includes(option.value)
                              : newUserForm.userGroups.includes(option.value)
                          )}
                          closeMenuOnSelect={false}
                          onChange={(selectedOptions) => {
                            const userGroups = selectedOptions.map(
                              (option) => option.value
                            );
                            if (editingUser) {
                              setEditingUser((prev) => ({
                                ...prev,
                                userGroups,
                              }));
                            } else {
                              setNewUserForm((prev) => ({
                                ...prev,
                                userGroups,
                              }));
                            }
                          }}
                          placeholder="Seleccionar grupos..."
                          className={E.selectClase}
                          classNamePrefix="select"
                          styles={E.select}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>

              </div>
            </Form>
          </div>

          <DialogFooter className={E.pie}>
            <BotonPie
              type="button"
              onClick={handleClose}
              disabled={loading}
              className={E.cancelar}
            >
              Cancelar
            </BotonPie>
            <BotonPie
              type="button"
              {...guia("Guardar", "Guarda los datos de la persona. Para darle acceso a Cierres usa después el botón Acceso de la lista.")}
              onClick={handleSubmit}
              disabled={loading}
              className={E.guardar}
            >
              {loading ? (
                <>
                  <Spinner size="sm" className="mr-2" />
                  <span>Procesando...</span>
                </>
              ) : (
                <span>{cierres ? (isEditing ? "Guardar cambios" : "Crear usuario") : isEditing ? "Guardar Cambios" : "Crear Usuario"}</span>
              )}
            </BotonPie>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  };

  if (acceso === undefined) {
    return (
      <div className="flex items-center justify-center py-12">
        <Spinner className="text-indigo-600" />
      </div>
    );
  }

  if (acceso) {
    return (
      <>
        <ToastContainer />
        <AccesoUsuarios
          token={props.token}
          mantisBusinessId={props.mantisBusiness._id}
          me={acceso}
          recarga={recargaAcceso}
          onCrearUsuario={canCreateUsers() ? () => setCreatingNewUser(true) : undefined}
          onEditarDatos={abrirEdicionPorId}
          onEliminar={handleDeleteUser}
        />
        {renderUserModal(!!editingUser)}
        <Dialog open={Boolean(porEliminar)} onOpenChange={(abierto) => !abierto && setPorEliminar(null)}>
          <DialogContent className="brinks-scope font-redhat max-w-md">
            <DialogHeader className="text-left">
              <div className="flex min-w-0 items-center gap-1">
                <DialogTitle className="text-[16px] font-semibold text-brinks-foreground">Eliminar usuario</DialogTitle>
                <BotonGuia
                  guiaId="dialogo-eliminar-usuario"
                  titulo="Eliminar usuario"
                  texto="La persona deja de poder entrar a la plataforma. Sus cierres, correcciones y observaciones siguen guardados con su nombre."
                />
              </div>
              <DialogDescription className="text-[12.5px] text-brinks-muted-foreground">
                {porEliminar?.firstName || porEliminar?.corporateEmail
                  ? `${[porEliminar.firstName, porEliminar.lastName].filter(Boolean).join(" ")} (${porEliminar.corporateEmail || ""}) ya no podrá entrar a la plataforma.`
                  : "Esta persona ya no podrá entrar a la plataforma."}
                {" "}No se puede deshacer.
              </DialogDescription>
            </DialogHeader>
            <DialogFooter className="gap-2">
              <button
                type="button"
                onClick={() => setPorEliminar(null)}
                className="inline-flex h-9 items-center rounded-[8px] border border-brinks-border bg-card px-4 text-[12.5px] font-medium text-brinks-foreground hover:bg-brinks-surface-hover"
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={() => {
                  const id = porEliminar._id;
                  setPorEliminar(null);
                  handleDeleteUser(id, { confirmado: true });
                }}
                className="inline-flex h-9 items-center rounded-[8px] bg-brinks-danger px-4 text-[12.5px] font-medium text-white hover:opacity-90"
              >
                Eliminar
              </button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </>
    );
  }

  return (
    <div className="p-6 space-y-6">
      <ToastContainer />

      {!creatingNewUser && !editingUser && (
        <div className="flex items-right justify-end">
          {canCreateUsers() && (
            <div className="flex items-center space-x-3">
              {/* <BulkUploadClientButton
                clientId={props.mantisBusiness._id}
                onClientsUploaded={() => {
                  // Recargar usuarios después de bulk upload
                  window.location.reload();
                }}
                size="default"
                variant="outline"
                showText={true}
                showIcon={true}
                tooltipText="Carga masiva de usuarios"
                className="whitespace-nowrap"
              /> */}
              <button
                onClick={() => setCreatingNewUser(true)}
                className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 rounded-xl shadow-sm transition-all"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
                <span>Crear Usuario</span>
              </button>
            </div>
          )}
        </div>
      )}

      {loading ? (
        <div className="flex items-center justify-center py-12">
          <div className="text-center space-y-4">
            <Spinner className="text-indigo-600" />
            <p className="text-slate-600 dark:text-slate-400">
              Cargando usuarios...
            </p>
          </div>
        </div>
      ) : (
        <>
          {!creatingNewUser &&
            !editingUser &&
            mantisBusinessUsers.length > 0 && (
              <div className="bg-white/70 dark:bg-slate-800/70 backdrop-blur-sm rounded-2xl border border-slate-200/50 dark:border-slate-700/50 shadow-sm overflow-hidden">
                <div className="overflow-x-auto">
                  <Table className="w-full">
                    <thead className="bg-slate-50/50 dark:bg-slate-700/50">
                      <tr>
                        <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                          Nombre
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                          Documento
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                          Cargo
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                          Email
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                          Teléfono
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                          Rol
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                          Canal Favorito
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                          Permisos
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-200/50 dark:divide-slate-700/50">
                      {mantisBusinessUsers.map((user) => (
                        <tr
                          key={user._id}
                          className="hover:bg-slate-50/50 dark:hover:bg-slate-700/50 transition-colors"
                        >
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex items-center space-x-3">
                              <div className="w-8 h-8 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-full flex items-center justify-center text-white text-sm font-medium">
                                {user.firstName?.charAt(0)}
                                {user.lastName?.charAt(0)}
                              </div>
                              <span className="text-sm font-medium text-slate-900 dark:text-slate-100">
                                {`${user.firstName} ${user.lastName}`}
                              </span>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-600 dark:text-slate-400">
                            {user.documentId || "-"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-600 dark:text-slate-400">
                            {user.position || "-"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-600 dark:text-slate-400">
                            {user.corporateEmail || "-"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-600 dark:text-slate-400">
                            {user.cellPhone ? `+${user.cellPhone}` : "-"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span
                              className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                                user.mainUser
                                  ? "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300"
                                  : user.supervisorUser
                                  ? "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300"
                                  : "bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-300"
                              }`}
                            >
                              {user.mainUser
                                ? "Administrador"
                                : user.supervisorUser
                                ? "Supervisor"
                                : "Usuario"}
                            </span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-600 dark:text-slate-400">
                            {user.favorite_channel ? (
                              <span
                                className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                                  user.favorite_channel === "whatsapp"
                                    ? "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300"
                                    : user.favorite_channel === "email"
                                    ? "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300"
                                    : "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300"
                                }`}
                              >
                                {user.favorite_channel === "whatsapp"
                                  ? "WhatsApp"
                                  : user.favorite_channel === "email"
                                  ? "Email"
                                  : user.favorite_channel === "forms"
                                  ? "Forms"
                                  : user.favorite_channel}
                              </span>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="px-6 py-4">
                            {formatPermissions(user.permissions, `${user.firstName} ${user.lastName}`)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex items-center space-x-2">
                              <button
                                onClick={() => abrirEdicion(user)}
                                className="p-2 text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300 hover:bg-indigo-50 dark:hover:bg-indigo-900/20 rounded transition-colors"
                              >
                                <svg
                                  className="w-4 h-4"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                  />
                                </svg>
                              </button>
                              <button
                                onClick={() => handleDeleteUser(user._id)}
                                className="p-2 text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300 hover:bg-red-50 dark:hover:bg-red-900/20 rounded transition-colors"
                              >
                                <svg
                                  className="w-4 h-4"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                  />
                                </svg>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            )}

          {renderUserModal(!!editingUser)}

          <Dialog open={!!permisosModal} onOpenChange={(open) => !open && setPermisosModal(null)}>
            <DialogContent className="max-w-lg max-h-[80vh] overflow-y-auto">
              <DialogHeader>
                <DialogTitle>Permisos de {permisosModal?.nombre}</DialogTitle>
                <DialogDescription>{permisosModal?.permisos.length} permisos asignados</DialogDescription>
              </DialogHeader>
              <div className="flex flex-wrap gap-1.5 py-2">
                {permisosModal?.permisos.map((permiso, index) => (
                  <span
                    key={index}
                    className="inline-flex items-center rounded bg-slate-100 px-2.5 py-1 text-xs font-medium text-slate-700 dark:bg-slate-700 dark:text-slate-200"
                  >
                    {permiso}
                  </span>
                ))}
              </div>
            </DialogContent>
          </Dialog>

          {!creatingNewUser &&
            !editingUser &&
            mantisBusinessUsers.length === 0 && (
              <div className="text-center py-12">
                <svg
                  className="mx-auto h-12 w-12 text-slate-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
                  />
                </svg>
                <h3 className="mt-2 text-sm font-medium text-slate-900 dark:text-slate-100">
                  No hay usuarios
                </h3>
                <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                  Comienza creando tu primer usuario del sistema.
                </p>
                {canCreateUsers() && (
                  <div className="mt-6 flex items-center justify-center space-x-4">
                    <BulkUploadClientButton
                      clientId={props.mantisBusiness._id}
                      onClientsUploaded={() => {
                        // Recargar usuarios después de bulk upload
                        window.location.reload();
                      }}
                      size="default"
                      variant="outline"
                      showText={true}
                      showIcon={true}
                      tooltipText="Carga masiva de usuarios"
                      className="whitespace-nowrap"
                    />
                    <button
                      onClick={() => setCreatingNewUser(true)}
                      className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 rounded-xl shadow-sm transition-all"
                    >
                      <svg
                        className="w-4 h-4 mr-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        />
                      </svg>
                      Crear Usuario
                    </button>
                  </div>
                )}
              </div>
            )}
        </>
      )}
    </div>
  );
}

export default connect(selectAuthState)(BusinessUsers);
